<template>
  <v-container>
    <v-app-bar color="transparent" class="elevation-0 pa-0 mb-4 page-header-toolbar" :height="'auto'">
      <page-header-title :title="$t('courses.title')" class="hidden-sm-only hidden-xs-only"></page-header-title>

      <v-layout row wrap>
        <v-flex xs12>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md4 class="text-right">
                <router-link :to="'/f/' + $getSetting('locale') + '/enrolment/organisation/interest'" target="_blank">
                  <action-button
                    type="new"
                    :text="$t('courses.cant_find_course')"
                    :icon="'search'"
                    :class="breakpointMdAndDown ? 'd-block' : ''"
                  />
                </router-link>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  :label="$t('global.search')"
                  v-model="search_params.any"
                  @keydown="checkKeyPress"
                  hide-details=""
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2 v-if="$vuetify.breakpoint.smAndUp">
                <v-select
                  v-model="search_params.coursetype_id"
                  :items="coursetypes"
                  item-text="name"
                  item-value="id"
                  :label="$t('coursetypes.title')"
                  @change="filter"
                  hide-details
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="$vuetify.breakpoint.smAndUp">
                <v-select
                  v-model="search_params.address_id"
                  :items="addresses"
                  item-text="city"
                  item-value="id"
                  :label="$t('addresses.title')"
                  @change="filter"
                  hide-details
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="computedHeaders"
            :items="courses"
            :items-per-page="courses.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.coursetype_id="{ item }">
              {{ item.coursetype.category }}
            </template>

            <template v-slot:item.address="{ item }">
              {{ item.address.city }}
            </template>

            <template v-slot:item.start_datetime="{ item }">
              {{
                item.start_date
                  ? moment.utc(item.start_date).format(DATE_FORMAT) + " " + moment.utc(item.start_time, TIME_FORMAT).format(TIME_FORMAT)
                  : null
              }}
            </template>

            <template v-slot:item.end_datetime="{ item }">
              {{
                item.end_date
                  ? moment.utc(item.end_date).format(DATE_FORMAT) + " " + moment.utc(item.end_time, TIME_FORMAT).format(TIME_FORMAT)
                  : null
              }}
            </template>

            <template v-slot:item.enrolment_due_date="{ item }">
              {{ moment.utc(item.enrolment_due_date).format(DATE_FORMAT) }}
            </template>

            <template v-slot:item.available_seats="{ item }">
              {{ item.available_seats > 0 ? $t("global.available") : $t("global.not_available") }}
            </template>

            <template v-slot:item.actions="{ item }">
              <!-- <router-link
                :to="{ path: '/f/no/enrolment/template/' + item.coursetemplate.uuid + '/course/' + item.uuid }"
                target="_blank"
              > -->
              <action-button
                type="default"
                :class="breakpointXsOnly ? 'mt-0 mb-2 btn-more' : 'btn-more'"
                small
                :text="$t('global.more')"
                @click="moreBtn(item)"
              />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showMoreCourse" persistent max-width="50%" class="mt-0">
      <v-card>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <p>{{ $t("fe.course.upcoming_full_confirm") }}</p>
          <v-flex xs12>
            <v-autocomplete
              v-model="selectedMoreCourse"
              :items="moreCourses"
              item-text="custom_name_4"
              item-value="id"
              autocomplete="new-password"
              clearable
            ></v-autocomplete>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <action-button small type="cancel" @click="closeMoreCourse()" />
          <router-link :to="{ path: '/f/no/enrolment/personal/interest' }" target="_blank">
            <action-button
              type="default"
              :class="breakpointXsOnly ? 'mt-0 mb-2 btn-more' : 'btn-more'"
              small
              :text="$t('fe.course.interest_form')"
            />
          </router-link>
          <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" @click="enrolMoreCourse" small>
            <v-icon small>fas fa-plus</v-icon>
            <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("enrolments.enrol") }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "CoursesList",

  props: ["locale"],

  data() {
    return {
      url: "",
      courses: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: 20,
        sortBy: ["start_datetime"],
        descending: "desc"
      },

      addresses: [],
      coursetypes: [],

      showMoreCourse: false,
      moreCourses: [],
      selectedMoreCourse: null,

      search_params: {
        any: "",
        name: "",
        coursetype_id: "",
        address_id: "",
        is_published: 1,
        upcoming_only: 1
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.refresh = true
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "open/courses"
  },

  created() {
    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale
  },

  computed: {
    computedHeaders() {
      let headers = [
        { text: this.$t("courses.name"), value: "name" },
        //{ text: this.$t("coursetypes.short_title"), value: "coursetype_id", hide: 'mdAndDown' },
        { text: this.$t("courses.location"), value: "address" },
        { text: this.$t("courses.start_datetime"), value: "start_datetime" },
        { text: this.$t("courses.end_datetime"), value: "end_datetime" },
        { text: this.$t("courses.enrolment_due_date"), value: "enrolment_due_date" },
        { text: this.$t("courses.status"), value: "available_seats" },
        {
          text: this.breakpointXsOnly ? "" : this.$t("global.actions"),
          value: "actions",
          width: "20%",
          align: "end",
          sortable: false,
          class: "textclass"
        }
      ]

      return headers.filter((h) => !h.hide || !this.$vuetify.breakpoint[h.hide])
    },
    breakpointMdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown
    },
    breakpointXsOnly() {
      return this.$vuetify.breakpoint.xsOnly
    }
  },

  methods: {
    list() {
      this.show_loading = true

      var params = JSON.parse(JSON.stringify(this.search_params))

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, params)

      axios.get(this.url + "?resourcetype=upcoming&" + query).then((res) => {
        this.courses = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })

      this.loadDropdown()
    },

    loadDropdown() {
      let lists = [
        { key: "addresses", module: "addresses", query: "show_all=true" },
        { key: "coursetypes", module: "coursetypes", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "open/request/ddlists", lists).then((res) => {
        this.addresses = res.data.addresses
        this.coursetypes = res.data.coursetypes
      })
    },

    filter(target) {
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.refresh = true
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },

    moreBtn(item) {
      // this.moment(item.enrolment_due_date).diff(moment(), 'days') < 0
      if (item.available_seats > 0) {
        this.$router.push("/f/no/enrolment/template/" + item.coursetemplate.uuid + "/course/" + item.uuid)
      } else {
        axios
          .get(
            this.url +
              "?show_all=true&resourcetype=upcoming&query_upcoming_only=1&query_is_published=1&query_coursetype_id=" +
              item.coursetype_id
          )
          .then((res) => {
            let courses = res.data.data
            this.moreCourses = courses.filter((x) => x.available_seats > 0)

            if(this.moreCourses.length) {
              this.showMoreCourse = true
            } else {
              this.$router.push('/f/no/enrolment/personal/interest')
            }
            
          })
      }
    },
    closeMoreCourse() {
      this.moreCourses = []
      this.showMoreCourse = false
      this.selectedMoreCourse = null
    },
    enrolMoreCourse() {
      let course = this.moreCourses.find((i) => i.id == this.selectedMoreCourse)
      if (course) {
        this.$router.push("/f/no/enrolment/template/" + course.coursetemplate.uuid + "/course/" + course.uuid)
      }
    }
  }
}
</script>

<style scoped>
/* action column in datatable in mobile */
.v-data-table__mobile-table-row .v-data-table__mobile-row:nth-child(5) {
  height: auto !important;
}
.btn-more {
  min-width: 60px !important;
}
</style>
